import strings from '../../../localization';
import { withSnackbar } from 'notistack';
import * as Actions from "../../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import SpecificationReportPage from './SpecificationReportPage';
import { generateCremationAveragesReport } from '../../../services/report/ReportService';

class CremationAveragesReport extends SpecificationReportPage {

  getFields() {
    return ['yearRange'];
  }

  getService() {
    return generateCremationAveragesReport;
  }

  getFileName() {
    return "1D-prosek-kremacija";
  }

  getPageTitle() {
    return strings.specificationReports.cremationAveragesTitle;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(CremationAveragesReport)));
